import { Award, Target, TrendingUp, Zap } from "lucide-react";
import { SectionEyebrow } from "@/components/Landing/primitives";

const REASONS = Object.freeze([
    {
        id: "ai-native",
        icon: Zap,
        title: "AI-native intake.",
        body: "Built from day one to read every credential at upload \u2014 classify the document, extract the data, flag what's wrong. The compliance officer reviews verified data instead of raw scans.",
    },
    {
        id: "intelligence",
        icon: TrendingUp,
        title: "Intelligence over storage.",
        body: "SENTINEL turns the platform's operational data into real-time leading and lagging indicators, contractor scorecards, and critical risk control verification \u2014 at project, region, and group level.",
    },
    {
        id: "end-to-end",
        icon: Target,
        title: "Compliance, end-to-end.",
        body: "Workforce, plant, subcontractors, permits, incidents, audits, and intelligence on a single schema. No second vendor for plant. No third for subcontractor management. No spreadsheets to fill the gaps.",
    },
    {
        id: "closer",
        icon: Award,
        title: "Closer to your team than a vendor twice our size.",
        body: "The founder takes the demo. Feature requests turn into builds in weeks. Australian-built, Australian-hosted, Australian-supported.",
    },
]);

export default function Why() {
    return (
        <section
            id="why"
            className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5 overflow-hidden"
        >
            <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl reveal">
                    <SectionEyebrow>
                        Why Tier 1 contractors choose Edara
                    </SectionEyebrow>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1] mt-3">
                        We're not trying to be the biggest. We're built to be
                        the smartest.
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {REASONS.map((c) => (
                        <article
                            key={c.id}
                            className="reveal lift rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-6"
                        >
                            <c.icon className="w-7 h-7 text-[#1FA8FF]" />
                            <h3 className="mt-5 font-sora font-semibold text-lg text-white leading-tight">
                                {c.title}
                            </h3>
                            <p className="mt-3 text-[14px] text-zinc-400 leading-relaxed">
                                {c.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
